// extracted by mini-css-extract-plugin
module.exports = {"links__category":"Links_links__category__d2fcs","links__list":"Links_links__list__vfGFB","links__link":"Links_links__link__Aqlev"};